export function isEmpty(obj) {
    if (obj === null || obj === undefined) return true;

    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    if (typeof obj === 'number' && !Number.isNaN(obj)) return false;

    if (typeof obj !== 'object') return true;

    return Object.keys(obj).length === 0 && obj.constructor === Object;
}